import { render, staticRenderFns } from "./TableSampleBitacora.vue?vue&type=template&id=1b88c60b&"
import script from "./TableSampleBitacora.vue?vue&type=script&lang=js&"
export * from "./TableSampleBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports